import inventoryListByWarehouse from '@/api/report/inventory-list-by-warehouse'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  report_type: '1',
  branch_id: '',
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_REPORT_TYPE(state, date) {
    state.report_type = date
  },
  SET_BRANCH_ID(state, date) {
    state.branch_id = date
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        report_type: context.state.report_type,
        branch_id: context.state.branch_id,
        search: context.state.search,
      },
      attributes
    )
    return inventoryListByWarehouse.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  getHeader(context, attributes = {}) {
    const params = Object.assign(
      {
        report_type: context.state.report_type,
        branch_id: context.state.branch_id,
      },
      attributes
    )
    return inventoryListByWarehouse.header({ params })
  },
  exportExcel(context) {
    return inventoryListByWarehouse.exportExcel({
      report_type: context.state.report_type,
      branch_id: context.state.branch_id,
      search: context.state.search,
    })
  }
}
